import AxiosService from '@/Services/AxiosService';
import LoaderService from '@/Services/LoaderService';
import { Inject, Service } from 'vue-di-container';

@Service()
export default class UpdateRequestsService {
    @Inject(AxiosService) public axiosService!: AxiosService;
    @Inject(LoaderService) public loaderService!: LoaderService;

    public async Get(model: any): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/update-requests';
            const result = await this.axiosService.axiosInstance.get(url, {
                params: model,
            });
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async GetDetails(id: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/update-requests/' + id;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async Approve(ids: string[], comment: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/update-requests/approve';
            const result = await this.axiosService.axiosInstance.put(url, {
                ids: ids,
                comment: comment,
            });
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async Reject(ids: string[], rejectionReason: string): Promise<any> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/update-requests/reject';
            const result = await this.axiosService.axiosInstance.put(url, {
                ids: ids,
                rejectionReason: rejectionReason,
            });
            this.loaderService.HideLoader();
            return result.data;
        } catch (exception) {
            this.loaderService.HideLoader();
            return false;
        }
    }

    public async GetUpdateRequestFileContent(id: string): Promise<string> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/update-requests/attachments/' + id;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            if (result.data && result.data.isSuccess && result.data.result) {
                return result.data.result;
            }
            return '';
        } catch (exception) {
            this.loaderService.HideLoader();
            return '';
        }
    }

    public async GetSenderRequestFileContent(id: string): Promise<string> {
        this.loaderService.ShowLoader();
        try {
            const url = window.$config.HostName + 'api/sender-requests/attachments/' + id;
            const result = await this.axiosService.axiosInstance.get(url);
            this.loaderService.HideLoader();
            if (result.data && result.data.isSuccess && result.data.result) {
                return result.data.result;
            }
            return '';
        } catch (exception) {
            this.loaderService.HideLoader();
            return '';
        }
    }
}
